/**
 * Change search bar visibility with bootstrap d-flex class d-none
 */
const navbarSearchBtn = document.getElementById("navbarSearchBtn");
let navbarSearchForm;

window.displaySearchClick = function () {
  navbarSearchForm = document.getElementById("navbarSearchForm");
  if (navbarSearchForm.classList.contains("d-none")) {
    navbarSearchForm.classList.remove("d-none");

    // Handle esc button
    $(".form-control").keyup(function (event) {
      if (event.keyCode == 27) {
        // Close the search section
        navbarSearchForm.classList.add("d-none");
        //  Return focus to the element that invoked it
        navbarSearchBtn.ariaExpanded = false;
        $("#close-search").addClass("d-none");
        $("#open-search").removeClass("d-none");
        $("#navbarSearchBtn").focus();
      }
    });
  } else {
    navbarSearchForm.classList.add("d-none");
  }
};

navbarSearchBtn.addEventListener("click", function () {
  displaySearchClick();
  let exbanded = !JSON.parse(navbarSearchBtn.ariaExpanded);
  navbarSearchBtn.ariaExpanded = exbanded;
  if (exbanded) {
    $("#open-search").addClass("d-none");
    $("#close-search").removeClass("d-none");
    $(".form-control").focus();
  } else {
    $("#close-search").addClass("d-none");
    $("#open-search").removeClass("d-none");
    $("#navbarSearchBtn").focus();
  }
});
